import { cva, type VariantProps } from 'class-variance-authority';

import type { JSX } from 'react';

import { cn } from '~/utils';
import { Text } from '~/components/text';
import { StarIcon } from '~/components/icons';

const ratingStatVariants = cva(cn('flex gap-2 items-center'), {
  variants: {
    size: {
      default: '',
      lg: '',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

const iconVariants = cva(cn('fill-[#f8d32e]'), {
  variants: {
    size: {
      default: 'size-4',
      lg: 'size-6',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

const ratingVariants = cva(cn('font-medium text-carbon-500'), {
  variants: {
    size: {
      default: 'text-sm leading-[130%]',
      lg: 'text-[32px] leading-[130%]',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

const countVariants = cva(cn('text-carbon-500'), {
  variants: {
    size: {
      default: 'text-sm leading-[130%]',
      lg: 'text-md leading-[130%]',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

interface IRatingStatProps extends VariantProps<typeof ratingStatVariants> {
  rating: number;
  ratingCount: number;
}

export function RatingStat({
  size,
  rating,
  ratingCount,
}: IRatingStatProps): JSX.Element {
  return (
    <div
      className={cn(
        ratingStatVariants({
          size,
        }),
      )}
    >
      <StarIcon
        className={iconVariants({
          size,
        })}
      />
      <Text
        className={ratingVariants({
          size,
        })}
      >
        {rating}
      </Text>
      <Text
        className={countVariants({
          size,
        })}
      >
        ({ratingCount})
      </Text>
    </div>
  );
}
